import React from "react";
import { Box, Heading, Container, Center } from "@chakra-ui/react";

const MissionVisionPage = () => {
  return (
    <Box w="100%" bg="white" borderRadius="2xl" py={10}>
      <Center>
        <Container maxW="container.xl">
          <Heading textAlign="center" color="teal.500">
            หน้าวัตถุประสงค์การจัดตั้ง พันธกิจและวิสัยทัศน์
          </Heading>
        </Container>
      </Center>
    </Box>
  );
};

export default MissionVisionPage;